import {groupBy, uniqBy} from 'lodash'
import {Ventrata} from 'types'

export const formatUnitItems = (unitItems: Ventrata.UnitItem[]) => {
  const groups = groupBy(unitItems, 'unitId')
  const initials = uniqBy(unitItems, 'unitId')

  const parts = []

  for (const unitItem of initials) {
    const group = groups[unitItem.unitId]
    const groupSize = group.length

    if (groupSize > 0) {
      parts.push(`${unitItem.unit.title} x ${groupSize}`)
    }
  }

  return parts.join(', ')
}
